import CQ9FISHActions from './CQ9FISHActions'

export default class CQ9EGAMEActions extends CQ9FISHActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'EGAME',
      gameCode: 'CQ9-EGAME-018',
      platform: 'CQ9',
    }

    this.gameName = 'Dragon Pachinko'
    this.roundIdPrefix = 'GO071'
    this.roundIdSuffix = ''

    // bet / cancelBet
    // platformTxId: rel-rollout-GO71132523:cq9
    // roundId: GO71132523

    // settle / resettle
    // platformTxId: GO71132523
    // roundId: GO71132523
  }
}
